module.exports = "data:image/svg+xml;base64,PHN2ZyBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiBvdmVyZmxvdz0idmlzaWJsZSIgc3R5bGU9ImRpc3BsYXk6IGJsb2NrOyIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiB2aWV3Qm94PSIwIDAgMzAgMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJhcnJvd19mb3J3YXJkXzI0ZHBfRkZGRkZGX0ZJTEwwX3dnaHQ0MDBfR1JBRDBfb3BzejI0IDEiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTcuNjUzMSAxNS44NzVIN1YxNC4xMjVIMTcuNjUzMUwxMi43NTMxIDkuMjI1TDE0IDhMMjEgMTVMMTQgMjJMMTIuNzUzMSAyMC43NzVMMTcuNjUzMSAxNS44NzVaIiBmaWxsPSJibGFjayIvPgo8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/icon-arrow-forward.svg
// module id = 1268
// module chunks = 4 5